import { isVanillaQaHostname } from "utils/siteEnvironment";

export const GARGANTUAN_QA_BASE_URL =
  "https://events-proxy-service.main.qa.sse-prod-eks-euw1.futureplc.engineering";

export const getGargantuanBaseUrl = (hostname: string): string => {
  if (!isVanillaQaHostname(hostname)) {
    return "";
  }

  return GARGANTUAN_QA_BASE_URL;
};

export const resolveGargantuanRequestUrl = (
  endpoint: string,
  hostname: string
): string => {
  const baseUrl = getGargantuanBaseUrl(hostname);

  if (!baseUrl) {
    return endpoint;
  }

  try {
    const resolvedEndpoint = new URL(endpoint, baseUrl);
    const qaUrl = new URL(baseUrl);
    const qaPathname = resolvedEndpoint.pathname.replace(
      /^\/\.events-handler\//,
      "/"
    );

    qaUrl.pathname = qaPathname;
    qaUrl.search = resolvedEndpoint.search;
    qaUrl.hash = resolvedEndpoint.hash;

    return qaUrl.toString();
  } catch {
    return endpoint;
  }
};
